import React, { Fragment } from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import IntelliFiberClientsUserConfiguration from './IntelliFiberClientsUserConfiguration';

const UpdateIntelliFiberClientsUserConfig = () => {
  return (
    <Fragment>
      <div className='container contA'>
        <Grid
          container
          sx={{
            minHeight: '450px',
            width: '100%',
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            padding: '1rem',
            margin: '1rem',
          }}
        >
          <IntelliFiberClientsUserConfiguration />
        </Grid>
      </div>
    </Fragment>
  );
};

export default UpdateIntelliFiberClientsUserConfig;
